<div class="d-none d-md-block">
  <div class="counter me-5 ms-5" [style.grid-template-columns]="'repeat(' + (indicators.length-1) +', 70px auto) 70px'">
    @for (item of indicators; track item; let i = $index) {
      @if (i > $currentPage-1 && i >= maxPage) {
        <span
        class="number low-opacity not-allowed">{{ i + 1 }}</span>
      } @else {
        <span class="number" (click)="setPage(i+1)" [class.low-opacity]="i > $currentPage-1">{{ i + 1 }}</span>
      }
      @if (i+1 < indicators.length) {
        <span class="separator" [class.low-opacity]="i+1 > $currentPage-1"></span>
      }
    }
  </div>
  <div class="counter me-4 ms-4 mt-2"
    [style.grid-template-columns]="'repeat(' + (indicators.length-1) +', 120px auto) 120px'">
    @for (text of indicators; track text; let i = $index) {
      <span class="text" [class.low-opacity]="i > $currentPage-1">
        {{ text }}
      </span>
      @if (i+1 < indicators.length ) {
        <span></span>
      }
    }
  </div>
</div>

<div class="text-info d-flex d-md-none flex-column justify-content-center align-items-center fw-bold">
  <span>
    Étape {{ $currentPage }} sur {{ indicators.length }}
  </span>
  <span>
    {{ indicators[$currentPage - 1] }}
  </span>
</div>
